module.exports = __webpack_public_path__ + "static/media/virus.1cae3bb8.png";